// removed by extract-text-webpack-plugin
module.exports = {"basketNotProcessed":"BasketList__basketNotProcessed___1lfkr","basketSelected":"BasketList__basketSelected___jIadX"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/Start/BasketList/BasketList.scss
// module id = 746
// module chunks = 0